import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import PageHeader from "../components/PageHeader";
import ProjectModal from "../components/ProjectModal";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { PROJECTS, PROJECT_CATEGORIES } from "../data/content";

export default function Portfolio() {
  const [filter, setFilter] = useState("All");
  const [selected, setSelected] = useState(null);

  const shown =
    filter === "All" ? PROJECTS : PROJECTS.filter((p) => p.category === filter);

  return (
    <>
      <PageHeader
        testid="portfolio-page-header"
        overline="Portfolio"
        title={["Homes we have", "lived in."]}
        intro="A selection of villas, penthouses and workspaces designed and executed by Aurea Living across Hyderabad — every one delivered on the promised date."
      />

      <section className="container-lux pb-28" data-testid="portfolio-section">
        <Reveal className="flex flex-wrap gap-3 mb-12" testid="portfolio-filters">
          {PROJECT_CATEGORIES.map((c) => (
            <button
              key={c}
              data-testid={`portfolio-filter-${c.toLowerCase()}`}
              onClick={() => setFilter(c)}
              className={`px-5 py-2 text-[12px] tracking-[0.14em] uppercase border transition-all duration-400 ${
                filter === c
                  ? "bg-espresso text-ivory border-espresso"
                  : "border-bronze/25 text-ink/60 hover:border-bronze hover:text-bronze"
              }`}
            >
              {c}
            </button>
          ))}
        </Reveal>

        <Stagger className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-7" gap={0.08} key={filter}>
          <AnimatePresence mode="popLayout">
            {shown.map((p) => (
              <StaggerItem key={p.id} className="md:last:col-span-2 md:last:max-w-[60%] md:last:mx-auto md:last:w-full">
                <motion.article
                  layout
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="group cursor-pointer"
                  onClick={() => setSelected(p)}
                  data-testid={`portfolio-card-${p.id}`}
                >
                  <div className="relative overflow-hidden aspect-[4/3]">
                    <img
                      src={p.cover}
                      alt={p.title}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-[1.2s] ease-luxe group-hover:scale-[1.06]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-espresso/70 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                    <span className="absolute bottom-4 right-4 grid h-11 w-11 place-items-center rounded-full bg-ivory text-ink opacity-0 translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                      →
                    </span>
                  </div>
                  <div className="mt-4 flex items-baseline justify-between gap-4">
                    <h2 className="font-serif text-2xl text-ink transition-colors duration-300 group-hover:text-bronze">
                      {p.title}
                    </h2>
                    <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-stone-500 whitespace-nowrap">
                      {p.location}
                    </p>
                  </div>
                  <p className="mt-1 text-[13px] font-light text-stone-warm">
                    {p.scope} · {p.area} · {p.year}
                  </p>
                </motion.article>
              </StaggerItem>
            ))}
          </AnimatePresence>
        </Stagger>
      </section>

      <AnimatePresence>
        {selected && <ProjectModal project={selected} onClose={() => setSelected(null)} />}
      </AnimatePresence>
    </>
  );
}
